import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import {
  BusinessUnitOutputDTO,
  ProductWorkUnitByBusinessUnitDTO,
  BusinessUnitInputDTO,
} from './businessUnitDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class BusinessUnitServices {
  async getById(id: number): Promise<BusinessUnitOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/business-unit/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByAll(
    params?: BusinessUnitInputDTO,
    queryParamsString?: string
  ): Promise<BusinessUnitOutputDTO[]> {
    try {
      const token = getJWT()
      let url = `${process.env.REACT_APP_URL_RESERVATION}/business-unit/`

      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
        params: {},
      }

      // Si hay params, añádelos a la configuración de Axios.
      if (params) {
        config.params = { ...params }
      }

      // Si hay queryParams como cadena, añádelos a la URL.
      if (queryParamsString) {
        url += `?${queryParamsString}`
      }

      const res = await axios.get(url, config)

      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async business_unit_filter(
    params?: BusinessUnitInputDTO,
    queryParamsString?: string
  ): Promise<BusinessUnitOutputDTO[]> {
    try {
      const token = getJWT()
      let url = `${process.env.REACT_APP_URL_RESERVATION}/business-unit/new-filter/`

      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
        params: {},
      }

      // Si hay params, añádelos a la configuración de Axios.
      if (params) {
        config.params = { ...params }
      }

      // Si hay queryParams como cadena, añádelos a la URL.
      if (queryParamsString) {
        url += `?${queryParamsString}`
      }

      const res = await axios.get(url, config)

      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getProductsByBusinessUnit(businessUnitId: number): Promise<ProductWorkUnitByBusinessUnitDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/product-work-unit-by-business-unit/business_unit_id/${businessUnitId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getProductsByBusinessUnits(queryParamsString?: string): Promise<ProductWorkUnitByBusinessUnitDTO[]> {
    try {
      let url = `${process.env.REACT_APP_URL_RESERVATION}/product-work-unit-by-business-unit/business_unit_ids/`
      if (queryParamsString) {
        url += `?${queryParamsString}`
      }
      const res = await axios.get(url, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getReservationByBusinessUnit(params: any = {}): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/reservation/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getReservationByBusinessUnitPayment(params: any = {}): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/reservation/filter-payment/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getReservationByBusinessUnitPaymentCompress(params: any = {}): Promise<any[]> {
    try {
      // const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/reservation/business_unit_compress/${params.business_unit_id}/${params.status}`, {
      //   headers: { 'authentication-token': getJWT()! },
      // })
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/reservation/business_unit_compress/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getReservationByBusinessUnitPaymentCompressPagination(urlPagination: string): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/reservation${urlPagination}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getPointOfSale() {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BILLING}/point-of-sale/`, {
        headers: { 'authentication-token': getJWT()! },
        // params: { ERP_system: 'TMA' },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getCreditsByBusinessUnitHash(hash: string) {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/business-unit/hash/${hash}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateCreditsByBusinessUnitHash(hash: string, body: any) {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_PAYMENT}/business-unit/hash/${hash}`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
  
  async getByOrderParent(user_id: string) {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/business-unit/user/`, {
        headers: { 'authentication-token': getJWT()! },
        params: user_id ? { user_id: user_id } : undefined,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByOrderParentCompress(user_id: string) {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/business-unit/user_id_compress/`, {
        headers: { 'authentication-token': getJWT()! },
        params: user_id ? { user_id: user_id } : undefined,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }


  async export(params: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/business-unit/export-xlsx/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async currencies_by_business_unit(business_unit_id: number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit/currencies-to/${business_unit_id}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async exchange_by_business_unit(business_unit_id: number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit/currencies/${business_unit_id}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async editBusinessNumber(sale_id: number, id:number): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BILLING}/update-sale-id`,
        {
          id,
          sale_id
        },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateCategory(business_unit_id: number, category:string): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit/update_category/${business_unit_id}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
          params:{
            category
          }
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getExtraBusinessUnit(business_unit_id: number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit-extra/`,
        {
          headers: { 'authentication-token': getJWT()! },
          params:{
            business_unit_id
          }
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createCondition(businessUnitExtra: any): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit-extra/`,
        {...businessUnitExtra},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateCondition(business_unit_extra_id:number, description: string): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit-extra/${business_unit_extra_id}`,
        {description},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteCondition(business_unit_extra_id:number): Promise<any> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit-extra/${business_unit_extra_id}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async uploadFileCondition(data:any): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit-extra/upload_file`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const businessUnitServices = new BusinessUnitServices()
